import React, { useState } from "react";
import Particles from "react-tsparticles";
import particlesConfig from "../../config/particlesConfig";
import MenuButton from "../../components/home-page/header/MenuButton";
import Menu from "../../components/home-page/header/Menu";
import Hero from "../../components/home-page/hero/Hero";
import Section1 from "../../components/home-page/section1/Section1";
import ReferencesMain from "../../components/home-page/references/ReferencesMain";
import ContactUs from "../../components/home-page/contact_us/ContactUs";
import CarouselHero from "../../components/home-page/hero/CarouselHero";

const HomePageMobile = function (props) {
  const [isMenuOpen, setMenu] = useState(false);

  const handleMenu = () => {
    setMenu((prevState) => !prevState);
  };

  return (
    <React.Fragment>
      <div style={{ position: "fixed" }}>
        <Particles height="100vh" width="100vw" params={particlesConfig} />
      </div>
      <header className="header">
        <MenuButton onClick={handleMenu}></MenuButton>
        <Menu
          isMenuOpen={isMenuOpen}
          onClick={handleMenu}
          setMenu={setMenu}
        ></Menu>
      </header>
      <main className="animation_on_load main">
        <section className="section_hero">
          <Hero></Hero>
          <CarouselHero></CarouselHero>
        </section>
        <section className="section_section1">
          <Section1></Section1>
        </section>
        <section className="section_references">
          <ReferencesMain></ReferencesMain>
        </section>
      </main>
      <footer>
        <section className="section_contact">
          <ContactUs></ContactUs>
        </section>
      </footer>
    </React.Fragment>
  );
};

export default HomePageMobile;
